'use client';

import type { FC } from 'react';
import { ScreenContent, ScreenFixedTop, ScreenTabBar } from '../../screen';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { InfoCard } from '../../components/ui/InfoCard';
import translations from './HowItWorksScreen.translations';

const stepGradients = [
  'bg-[linear-gradient(135deg,#a855f7_0%,#ec4899_100%)]',
  'bg-[linear-gradient(135deg,#3b82f6_0%,#06b6d4_100%)]',
  'bg-[linear-gradient(135deg,#22c55e_0%,#10b981_100%)]',
  'bg-[linear-gradient(135deg,#eab308_0%,#f97316_100%)]',
  'bg-[linear-gradient(135deg,#6366f1_0%,#8b5cf6_100%)]',
  'bg-[linear-gradient(135deg,#0ea5e9_0%,#3b82f6_100%)]',
];

export const HowItWorksScreen: FC = () => {
  const { t } = useLocalTranslation(translations);

  const steps = [
    { title: t('step1Title'), text: t('step1Text') },
    { title: t('step2Title'), text: t('step2Text') },
    { title: t('step3Title'), text: t('step3Text') },
    { title: t('step4Title'), text: t('step4Text') },
    {
      title: t('step5Title'),
      text: t('step5Intro'),
      items: [t('step5Item1'), t('step5Item2'), t('step5Item3')],
    },
    { title: t('step6Title'), text: t('step6Text') },
  ];

  return (
    <>
      <ScreenFixedTop title={t('title')} />
      <ScreenTabBar />
      <ScreenContent>
        <div className="mx-auto flex max-w-2xl flex-col gap-4 p-4 pb-8">
          <p className="text-[rgb(209,213,219)] text-sm leading-relaxed m-0">{t('intro')}</p>

          <div className="flex flex-col gap-3">
            {steps.map((step, i) => (
              <InfoCard key={i}>
                <div className="mb-3 flex items-center gap-3">
                  <div className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full ${stepGradients[i]}`}>
                    <span className="text-sm font-bold text-white">{i + 1}</span>
                  </div>
                  <h2 className="m-0 text-base font-bold text-white">{step.title}</h2>
                </div>
                <p className="m-0 text-sm leading-normal text-[rgb(209,213,219)]">{step.text}</p>
                {step.items && (
                  <ul className="mt-3 flex list-none flex-col gap-1.5 ps-0">
                    {step.items.map((item, j) => (
                      <li
                        key={j}
                        className="flex items-start gap-1.5 text-sm leading-snug text-[rgb(209,213,219)] [&>i]:mt-0.5 [&>i]:shrink-0 [&>i]:text-sm [&>i]:text-purple-500"
                      >
                        <i className="ri-checkbox-circle-fill" />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </InfoCard>
            ))}
          </div>
        </div>
      </ScreenContent>
    </>
  );
};
